export const MIN_ZOOM = 0.1;
export const MAX_ZOOM = 3.5;
export const DEFAULT_STATE = { x: 0, y: 0, z: 1 };
